(function () {
  'use strict';

  if (window.THDSeenOnDealers) {
    window.THDSeenOnDealers.initialize(document);
    return;
  }

  function play(video) {
    if (!video || video.dataset.thdAutoplay !== 'true') return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    var result = video.play();
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }

  function prepare(video) {
    if (video.dataset.thdPlaybackReady === 'true') {
      play(video);
      return;
    }
    video.dataset.thdPlaybackReady = 'true';
    video.addEventListener('loadedmetadata', function () { play(video); });
    video.addEventListener('canplay', function () { play(video); });
    play(video);
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[data-thd-seen-video]').forEach(prepare);
  }

  window.THDSeenOnDealers = { initialize: initialize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  window.addEventListener('pageshow', function () { initialize(document); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
